import { ReservationTimeState as ReservationTimeStateEnum } from '@mews-commander/data-access';
import { enumify, Enumify } from '@mews/enumify';

function ReservationTimeState() {}
enumify<ReservationTimeStateEnum, number>(ReservationTimeState, 'ReservationTimeState', {
    Past: 0,
    CheckOutMissed: 1,
    ToBeCheckedOut: 2,
    CheckedIn: 3,
    CheckInMissed: 4,
    ToBeCheckedIn: 5,
    Future: 6,
    ToBeConfirmed: 7,
    ConfirmationMissed: 8,
});

export default ReservationTimeState as unknown as Enumify<ReservationTimeStateEnum, number>;
